// extracted by mini-css-extract-plugin
export var content = "ModalContent-module--content--16b99";
export var fadeInAnimation = "ModalContent-module--fadeInAnimation--795ca";
export var scrollWrapper = "ModalContent-module--scrollWrapper--ae747";
export var selectWrapper = "ModalContent-module--selectWrapper--209dd";
export var tagsWrapper = "ModalContent-module--tagsWrapper--9e78d";